import { NeedsListView } from "./NeedsListView";

export const Behovsliste = () => (
  <NeedsListView
    titleKey="Needs overview"
    descriptionKey="All registered needs."
    mineOnly={false}
    urlStatusSync={true}
  />
);
